__turbopack_context__.v({
  "spinner": "HBIYYG_spinner",
});
